// path: assets/toolbar.js

class Toolbar extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.mediaView = this.querySelector('.media-view');
        this.mediaViewMobile = this.querySelector('.media-view-mobile');
        this.limitView = this.querySelector('.limit-view');
        this.sortButton = this.querySelector('.sort-button');
        this.sortMenu = document.querySelector('.sort-menu');

        if (this.mediaView) {
            this.mediaView.addEventListener('click', this.onClickModeButtonHandler.bind(this));
        }
        if (this.mediaViewMobile) {
            this.mediaViewMobile.addEventListener('click', this.onClickModeButtonMobileHandler.bind(this));
        }
        if (this.limitView) {
            this.limitView.addEventListener('click', this.onClickLimitButtonHandler.bind(this));
        }
        if (this.sortButton) {
            this.sortButton.addEventListener('click', this.onClickSortButtonHandler.bind(this));
        }

        document.addEventListener('click', this.handleClickOutside.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleClickOutside(event) {
        if (this.sortMenu && !this.sortMenu.contains(event.target) && event.target !== this.sortMenu) {
            this.sortMenu.classList.remove('open');
        }
    }

    handleScroll() {
        if (this.sortMenu && this.sortMenu.classList.contains('open')) {
            this.sortMenu.classList.remove('open');
        }
    }

    onClickSortButtonHandler(event) {
        event.preventDefault();
        if (this.sortMenu) {
            this.sortMenu.classList.toggle('open');
        }
    }

    changeBannerPositions(column) {
        const collectionProductGrid = document.getElementById('CollectionProductGrid').querySelector('.productListing');
        const banner1 = collectionProductGrid.querySelector('.collection-banner-adv[data-product-banner="1"]');
        const banner2 = collectionProductGrid.querySelector('.collection-banner-adv[data-product-banner="2"]');
        const banner3 = collectionProductGrid.querySelector('.collection-banner-adv[data-product-banner="3"]');

        const bannerLists = [banner1, banner2, banner3];

        const getCurrentPosition = (banner, index) => ({
            bannerNumber: index + 1,
            originalIndex: [...collectionProductGrid.children].indexOf(banner),
        });

        const getNextPosition = (info) => {
            let nextPosition;
            switch (info.bannerNumber) {
                case 1:
                    nextPosition = 0;
                    break;
                case 2:
                    nextPosition = 8;
                    collectionProductGrid.classList.add('banner-full-width');
                    break;
                case 3:
                    nextPosition = info.originalIndex - 1;
                    break;
                case 4:
                    nextPosition = info.originalIndex;
                    break;
                case 5:
                    nextPosition = info.originalIndex + 1;
                    break;
                default:
                    collectionProductGrid.classList.remove('banner-full-width');
            }
            return {
                bannerNumber: info.bannerNumber,
                originalIndex: info.originalIndex,
                currentIndex: nextPosition,
            };
        };

        const clearBanner = () => {
            bannerLists.forEach(banner => collectionProductGrid.removeChild(banner));
        };

        const setBannerPosition = (nextInfo) => {
            const clearedList = [...collectionProductGrid.querySelectorAll('.product')];
            let productBefore = clearedList[nextInfo.currentIndex];

            const bannerToAppend = bannerLists.find(banner => banner.dataset.productBanner == nextInfo.bannerNumber);
            collectionProductGrid.insertBefore(bannerToAppend, productBefore);
        };

        const bannersInfo = bannerLists.map(getCurrentPosition);
        const bannersNextInfo = bannersInfo.map(getNextPosition);
        clearBanner();
        bannersNextInfo.forEach(setBannerPosition);
    }

    initViewModeLayout(column) {
        const productListing = document.getElementById('CollectionProductGrid').querySelector('.productListing');
        if (!productListing) return;

        switch (column) {
            case 1:
                productListing.classList.remove('productGrid', 'column-5', 'column-4', 'column-3', 'column-2');
                productListing.classList.add('productList');
                break;
            case 2:
                productListing.classList.remove('productList', 'column-5', 'column-4', 'column-3');
                productListing.classList.add('productGrid', 'column-2');
                break;
            case 3:
                productListing.classList.remove('productList', 'column-5', 'column-4', 'column-2');
                productListing.classList.add('productGrid', 'column-3');
                break;
            case 4:
                productListing.classList.remove('productList', 'column-5', 'column-3', 'column-2');
                productListing.classList.add('productGrid', 'column-4');
                break;
            case 5:
                productListing.classList.remove('productList', 'column-4', 'column-3', 'column-2');
                productListing.classList.add('productGrid', 'column-5');
                break;
        }

        if (document.querySelector('.collection-masonry')) {
            resizeAllGridItems();
        }

        if (document.querySelector('.collection-banner-adv')) {
            this.changeBannerPositions(column);
        }
    }

    onClickModeButtonHandler(event) {
        event.preventDefault();

        const buttonElement = event.currentTarget;
        const viewMode = this.mediaView.querySelector('.icon-mode.active');
        const column = parseInt(buttonElement.dataset.col);

        if (!buttonElement.classList.contains('active')) {
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaViewMobile.querySelectorAll('.icon-mode').forEach((element) => {
                const currentColum = parseInt(element.dataset.col);
                if (currentColum == column) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickModeButtonMobileHandler(event) {
        event.preventDefault();

        const buttonElement = event.currentTarget;
        const viewMode = this.mediaViewMobile.querySelector('.icon-mode.active');
        const column = parseInt(buttonElement.dataset.col);

        if (!buttonElement.classList.contains('active')) {
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaView.querySelectorAll('.icon-mode').forEach((element) => {
                const currentColum = parseInt(element.dataset.col);
                if (currentColum == column) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickLimitButtonHandler(event) {
        event.preventDefault();

        const buttonElement = event.currentTarget;
        if (!buttonElement.classList.contains('is-active')) {
            const value = parseInt(buttonElement.querySelector('.text').dataset.value);

            this.limitView.querySelector('.label-text').innerText = value;
            this.limitView.querySelector('[data-toggle]').setAttribute('aria-expanded', false);

            this.limitView.querySelectorAll('[data-limited-view-item]').forEach((limitButton) => {
                limitButton.classList.remove('is-active');
            });

            buttonElement.classList.add('is-active');

            $.ajax({
                type: 'POST',
                url: '/cart.js',
                dataType: 'json',
                data: {
                    "attributes[pagination]": value
                },
                success: function (data) {
                    window.location.reload();
                },
                error: function (xhr, text) {
                    alert($.parseJSON(xhr.responseText).description);
                },
            });
        }
    }
}

customElements.define('toolbar-item', Toolbar);
